import { c as _c } from "react/compiler-runtime";
import { createQueryFn, wagerQueryKeys } from '../../../../lib/entry.js';
import { useSuspenseQuery } from '../../../../tanstack/entry.js';
import { getWager } from '../../../actions/wager/entry.js';
const fetcher = createQueryFn(getWager);
/**
 * Function to get wager details.
 *
 * @param wagerId Id of the wager to fetch
 * @param queryOptions Fetch query options
 * @returns Wager details
 */
export function useWager(wagerId, queryOptions) {
  const $ = _c(8);
  let t0;
  if ($[0] !== wagerId) {
    t0 = wagerQueryKeys.wager(wagerId);
    $[0] = wagerId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = queryOptions?.defaultValue;
  let t2;
  if ($[2] !== t1) {
    t2 = fetcher({
      defaultValue: t1
    });
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== queryOptions || $[5] !== t0 || $[6] !== t2) {
    t3 = {
      ...queryOptions,
      queryKey: t0,
      queryFn: t2
    };
    $[4] = queryOptions;
    $[5] = t0;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useSuspenseQuery(t3);
}